import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, ViewEncapsulation } from '@angular/core';

import { BrandsEnum, IMedia, SdBannerComponent, SdHtmlComponent, SdLibConfig } from '@seb/web-design-system/core';

@Component({
  selector: 'sd-product-benefit',
  templateUrl: './product-benefit.component.html',
  styleUrls: ['./product-benefit.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdBannerComponent,
    SdHtmlComponent
  ]
})
export class SdProductBenefitComponent implements OnChanges {
  @Input()
  brand: BrandsEnum;

  @Input()
  media: IMedia;

  @Input()
  description: string;

  @Input()
  horizontalParentLayout = false;

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, this.hasBorder ? 'has-border' : '']
      .filter(Boolean)
      .join(' ');
  }

  hasBorder!: boolean;

  constructor(private sdLibConfig: SdLibConfig) {}

  ngOnChanges() {
    this.hasBorder = this.sdLibConfig.get(this.brand).productBenefitHasBorder;
  }
}
